import axios from 'axios';
import Config from 'config/Config';

interface TermsResolver {
  Query: {
    getTerms: (
      _: unknown,
      __: unknown,
      context: { client: { defaultOptions: { config: Config } } }
    ) => Promise<{ terms: string }>;
  };
}

const termsResolvers: TermsResolver = {
  Query: {
    getTerms: async (_, __, { client }) => {
      const { config } = client.defaultOptions;

      try {
        const { data } = await axios.get(config.getTermsUrl());

        return { terms: data };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (error: any) {
        throw new Error(error.message);
      }
    },
  },
};

export default termsResolvers;
